import * as React from "react";
import {
  Box,
  Button,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Typography,
  IconButton,
  Autocomplete,
  TextField,
  Checkbox,
  InputLabel,
  CircularProgress,
} from "@mui/material";
import { useLocation } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import { useState, useEffect, useRef } from "react";
import EditableTable from "../TableView/EditTable";
import Header from "../Header/Header";
import "./DetailsView.css";
import bgImage from "../Assets/bgImgsecondpage.png";
// import destinationcountry from "../Assets/destinationcountry.png";
import originCountryImg from "../Assets/origincountry.png";
// import "./DetailsView.css";
import destinationCountryImg from "../Assets/Property 1=GlobeHemisphereEast.png";
import destinationPortImg from "../Assets/Property 1=Anchor.png";
import factoryLocationImg from "../Assets/Property 1=Factory.png";
import PortAndCityRow from "../PortAndCity/PortAndCity";
import axiosInstance from "../Utils/AxoisClient";
import packageIMg from "../Assets/Package.png";
import ListboxComponent from "../DynamicAutocomplete/DynamicAutocomplete";
import { toast, ToastContainer } from "react-toastify";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  ...theme.applyStyles("dark", {
    backgroundColor: "#1A2027",
  }),
}));

const fontStyle = {
  fontFamily: "Inter",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 500,
  lineHeight: "normal",
  letterSpacing: "-0.387px",
};

const dropDownHeader = {
  display: "flex",
  float: "left",
  // color: "#252F40",
  color: "white",
  fontFamily: "Inter",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 500,
  lineHeight: "normal",
  letterSpacing: "-0.387px",
  marginBottom: "8px",
};

const backgroundStyle = {
  padding: "20px",
  // backgroundImage: `url(${earth})`,
  backgroundImage: `url(${bgImage})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundColor: "#00008b",
};

const FirstParaStyle = {
  // height: "40vh",
  marginTop: "0",
  color: "white",
  // padding: "10px",
};

const dropDownStyle = {
  backgroundColor: "#ffffff",
  borderRadius: 2,
  textAlign: "center",
  background: "#dbdef4",
  textAlign: "left",
  transition: "box-shadow 0.15s ease",
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
  "&.Mui-focused": {
    boxShadow: "0 0 0 2px rgba(89, 45, 255, 0.25)",
  },
};

const selectedBoxStyle = {
  color: " var(--entered-text, #2C2C2E)",
  backgroundColor: "#ffffff",
  borderRadius: 2,
  textAlign: "center",
  background: "#dbdef4",
  textAlign: "left",
  fontSize: "14px",
  padding: "5px",
  fontWeight: 500,
  letterSpacing: "-0.387px",
  border: "none",
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
};
const MenuProps = {
  PaperProps: {
    style: {
      fontSize: "9px",
      padding: "4px 8px",
    },
  },
};
const menuColor = {
  background: "#dbdef4",
};

const placeHolderStyle = {
  width: "100%",
  textAlign: "center",
  color: "#8d8f9d",
  fontSize: 12,
};
export default function DetailsView(params) {
  const location = useLocation();
  // const { selectedHSCode } = location.state || {};
  const [selectedRows, setSelectedRows] = useState(
    location.state?.selectedRows || [],
  );
  const [selectedHeader, setSelectedHeader] = useState(
    location.state?.selectedHeader || "",
  );
  const [selectedMaterial, setSelectedMaterial] = useState(
    location.state?.selectedMaterial || {},
  );
  const [id, setId] = useState(location.state?.id || null);
  const [from, setFrom] = useState(location.state?.from || "");
  const [destinationCountryList, setDestinationCountryList] = useState([]);
  const [destinationCountryData, setDestinationCountryData] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [cityList, setCityList] = useState([]);
  const [portList, setPortList] = useState([]);
  const [originCountryDetails, setOriginCountryDetails] = useState([]);
  const [originCountryDetailsUpdated, setOriginCountryDetailsUpdated] =
    useState([]);
  const [currencyList, setCurrencyList] = useState([]);
  // const [selectedOriginCity, setSelectedOriginCity] = useState("");
  const [selectedPort, setSelectedPort] = useState("");
  const [goButton, setGoButton] = useState(false);
  const [originCountry, setOriginCountry] = useState([]);
  const scrollToDownRef = React.useRef(null);
  //sub category
  const [subCategory, setSubCategory] = useState([]);
  const hasInitializedSubCategory = React.useRef(false);
  const subCategoryAbortRef = React.useRef(null);
  const [subCategoryPage, setSubCategoryPage] = useState(1);
  const [subCategoryHasMore, setSubCategoryHasMore] = useState(true);
  const [subCategorySearch, setSubCategorySearch] = useState("");
  const [loadingSubCategory, setLoadingSubCategory] = useState(false);
  const [loadingHSCode, setLoadingHSCode] = useState(false);
  const [loadingMaterial, setLoadingMaterial] = useState(false);
  const [selectedSubCategory, setSelectedSubCategory] = React.useState(null);
  const [hasInitialized, setHasInitialized] = useState(false);
  //hs code
  const [HSCode, setHSCode] = useState([]);
  const [selectedHSCode, setSelectedHSCode] = React.useState(
    location.state?.selectedHSCode || "",
  );
  const [hsCodeSearch, setHsCodeSearch] = useState("");
  //Material list
  const [materialList, setMaterialList] = useState([]);
  //origin country
  const [originCountryList, setOriginCountryList] = useState([]);
  const [userEdited, setUserEdited] = useState(false);
  const debounceTimerSubCategoryRef = useRef(null);
  // Tracks the subcategory id (or "" for none) we last auto-selected the
  // first HS Code for, so the auto-select only fires on land/category-
  // change, never while the user is actively searching.
  const hsCodeAutoSelectedForRef = useRef(undefined);
  // True while the user has typed search text into the Material box —
  // Material has no dedicated search state (fetchDataMaterial takes the
  // search value as a param), so this tracks it separately.
  const materialSearchActiveRef = useRef(false);
  // Tracks the HS Code we last auto-selected the first Material for.
  const materialAutoSelectedForRef = useRef(undefined);
  const debounceTimerRef = useRef(null);

  useEffect(() => {
    setSelectedRows(location.state?.selectedRows || []);
    setSelectedHeader(location.state?.selectedHeader || "");
    setSelectedMaterial(location.state?.selectedMaterial || {});
    setId(location.state?.id || null);
    setFrom(location.state?.from || "");
    setSelectedSubCategory(location.state?.selectedSubCategory);
  }, [location.state]);

  const fetchDataSubCategory = async (value, page = subCategoryPage) => {
    if (subCategoryAbortRef.current) subCategoryAbortRef.current.abort();
    const controller = new AbortController();
    subCategoryAbortRef.current = controller;
    setLoadingSubCategory(true);

    const payload = { name: value ? value : "" };
    try {
      const response = await axiosInstance.post(
        `company/subcategory-list?limit=500&page=${page}`,
        payload,
        { signal: controller.signal },
      );
      const newItems = response?.data?.data || [];
      setSubCategory((prev) =>
        page === 1 ? newItems : [...prev, ...newItems],
      );
      setSubCategoryHasMore(newItems.length > 0);
      if (!hasInitializedSubCategory.current && newItems.length > 0) {
        hasInitializedSubCategory.current = true;
      }
      setLoadingSubCategory(false);
    } catch (error) {
      if (error.code === "ERR_CANCELED") return;
      setLoadingSubCategory(false);
      toast.error(error?.response?.data?.message, { autoClose: 2000 });
    }
  };
  //sub category
  useEffect(() => {
    // if () {
    fetchDataSubCategory();
    // }
  }, [location.state?.from]);
  const abortRef = React.useRef(null);

  const subCategoryId = React.useMemo(
    () => selectedSubCategory?.id ?? null,
    [selectedSubCategory],
  );

  // Debounce with null value support
  const [debouncedSubCategoryId, setDebouncedSubCategoryId] =
    React.useState(subCategoryId);

  React.useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSubCategoryId(subCategoryId);
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [subCategoryId]);

  const isInitialHSCodeFetch = React.useRef(true);

  React.useEffect(() => {
    // Skip initial fetch when coming from dashboard
    if (isInitialHSCodeFetch.current && from === "dashboard") {
      isInitialHSCodeFetch.current = false;
      return;
    }
    isInitialHSCodeFetch.current = false;

    const controller = new AbortController();
    let isMounted = true;

    const fetchData = async () => {
      setLoadingHSCode(true);
      try {
        const payload = {
          subcategory_id: debouncedSubCategoryId ?? "",
          hsncode: hsCodeSearch || "",
        };

        const response = await axiosInstance.post(
          "company/hsncode-list?limit=400&page=1",
          payload,
          { signal: controller.signal },
        );

        if (controller.signal.aborted || !isMounted) {
          return;
        }

        setHSCode(response?.data?.data);
        setLoadingHSCode(false);

        if (from !== "bookmark") {
          // setSelectedHSCode(response?.data?.data?.[0] || {});
        }
      } catch (error) {
        if (
          error.name === "CanceledError" ||
          error.code === "ERR_CANCELED" ||
          controller.signal.aborted
        ) {
          return;
        }

        if (!isMounted) return;
        setLoadingHSCode(false);

        toast.error(error?.response?.data?.message || "Failed to fetch", {
          autoClose: 2000,
        });
      }
    };

    fetchData();

    return () => {
      isMounted = false;
      controller.abort();
    };
    // }, [debouncedSubCategoryId, from]);
  }, [debouncedSubCategoryId, from, hsCodeSearch]);

  //origin country
  useEffect(() => {
    let originCountryList = "";
    if (selectedHeader === selectedCountry) {
      selectedRows &&
        selectedRows.forEach((element) => {
          originCountryList += element.origin_country_name + ",";
        });
    }
    // setOriginCountry(originCountryList);
  }, [selectedRows, selectedHeader, selectedCountry]);

  //city and port and country
  React.useEffect(() => {
    const material_name = selectedMaterial?.material_name;
    const destinationCountry = (selectedCountry || selectedHeader || "").trim();

    // HS Code is an optional refinement here, not a prerequisite — City/
    // Port data depends on Material + Destination Country, and requiring
    // HS Code too meant this fetch silently never ran (leaving City/Port
    // empty) whenever a user arrived without one already selected, e.g.
    // via "Click for more details" from the Tariff page.
    if (!destinationCountry) return;

    const fetchData = async () => {
      let originCountryList = "";

      const payload = {
        material_name: material_name ?? "",
        hsncode: selectedHSCode?.hsncode,
        origin_country: originCountry ? originCountryList : "",
        destination_country: destinationCountry,
      };
      try {
        let response = [];
        if (id) {
          response = await axiosInstance.post("company/bookmark/tariff-data", {
            id: id,
          });
          setGoButton(true);
        } else {
          response = await axiosInstance.post("company/tariff-details", {
            ...payload,
          });
        }
        const countryList = response?.data?.data?.destinationCountryData?.map(
          (ele) => ele?.destination_country,
        );
        setDestinationCountryData(response?.data?.data?.destinationCountryData);
        const match = response?.data?.data?.destinationCountryData?.find(
          (ele) => ele?.destination_country === destinationCountry,
        );
        const originCountryData = response?.data?.data?.originCountryData;
        if (from === "bookmark") {
          setOriginCountryDetailsUpdated(originCountryData);
          setSelectedSubCategory(response?.data?.data?.subcategory);
        }
        const cityList = match?.destination_city;
        const portList = match?.destination_port;
        setOriginCountryDetails(originCountryData);
        setDestinationCountryList(countryList);
        setPortList(portList);
        setCityList(cityList);
        setSelectedCity((cityList && cityList[0]) || null);
        setSelectedPort((portList && portList[0]) || null);
      } catch (error) {
        toast.error(error?.response?.data?.message, { autoClose: 2000 });
      }
    };
    fetchData();
    // alert()
  }, [
    selectedHeader,
    selectedCountry,
    originCountry,
    from,
    selectedMaterial,
    selectedHSCode,
    id,
  ]);

  //to get currency list
  useEffect(() => {
    const getCurrency = async () => {
      const payload = {
        country: "",
      };
      try {
        const response = await axiosInstance.post(
          "company/currency-list",
          payload,
        );
        setCurrencyList(response?.data?.data);
        // return response;
      } catch (error) {
        toast.error("Failed to fetch currency list", { autoClose: 2000 });
      }
    };
    getCurrency();
  }, []);

  // const fetchDataMaterial = async (value) => {
  //   // if (!selectedHSCode?.hsncode && !selectedSubCategory?.id) return;
  //   // if (!value && !selectedHSCode?.hsncode && !selectedSubCategory?.id) return;
  //   const payload = {
  //     subcategory_id: selectedSubCategory?.id || "",
  //     hsncode: selectedHSCode?.hsncode || "",
  //     material_name: value ? value : "",
  //   };

  //   try {
  //     const response = await axiosInstance.post(
  //       "company/material-list?limit=400&page=1",
  //       payload,
  //     );

  //     const materials = response?.data?.data || [];

  //     setMaterialList(materials);
  //     if (materials.length > 0 && !value) {
  //       // setSelectedMaterial({ material_name: materials[0].material_name });
  //     }
  //   } catch (error) {
  //     toast.error(error?.response?.data?.message, { autoClose: 2000 });
  //   } finally {
  //     // setLoadingMaterial(false);
  //   }
  // };

  // React.useEffect(() => {
  //   fetchDataMaterial(false);
  // }, [selectedHSCode, selectedSubCategory]);

  // const seen = new Set();
  // // const cityList1 = DropDown.DropDown[0]
  // //   .filter((ele) => ele.Country === selectedCountry)
  // //   .map((ele) => ele["Factory City"])
  // //   .filter((city) => {
  // //     const key = city?.trim().toLowerCase();
  // //     if (!key || seen.has(key)) return false;
  // //     seen.add(key);
  // //     return true;
  // //   });

  // const originCity = [
  //   ...new Set(
  //     DropDown.DropDown[0]
  //       .filter((ele) => ele.Country === selectedCountry)
  //       .map((ele) => ele["Origin City"])
  //       .filter(
  //         (port) =>
  //           port && // removes null/undefined/empty
  //           typeof port === "string" &&
  //           port.trim() !== "" &&
  //           port.toLowerCase() !== "not applicable"
  //       )
  //   ),
  // ];

  // // const portList = [
  // //   ...new Set(
  // //     DropDown.DropDown[0]
  // //       .filter((ele) => ele.Country === selectedCountry)
  // //       .map((ele) => ele["Port City"])
  // //   ),
  // // ];

  // // const portList = [
  // //   ...new Set(
  // //     DropDown.DropDown[0]
  // //       .filter((ele) => ele.Country === selectedCountry)
  // //       .map((ele) => ele["Port City"])
  // //       .filter((port) => port?.toLowerCase() !== "not applicable") // remove "Not applicable"
  // //   ),
  // // ];

  const abortControllerRef = React.useRef(null);

  const fetchDataMaterial = React.useCallback(
    async (value) => {
      // Cancel previous request
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }

      // Create new controller
      const controller = new AbortController();
      abortControllerRef.current = controller;

      const payload = {
        subcategory_id: selectedSubCategory?.id || "",
        hsncode: selectedHSCode?.hsncode || "",
        material_name: value ? value : "",
      };

      setLoadingMaterial(true);
      try {
        const response = await axiosInstance.post(
          "company/material-list?limit=400&page=1",
          payload,
          { signal: controller.signal },
        );

        // Check if this request was aborted
        if (controller.signal.aborted) return;
        // Ignore a response that resolved after the HS Code moved on —
        // the abort above only covers requests this function itself
        // superseded, not ones superseded by a HS Code change that
        // happened after this specific call was already in flight.
        if ((selectedHSCode?.hsncode || "") !== payload.hsncode) return;

        const materials = response?.data?.data || [];

        setMaterialList(materials);
        setLoadingMaterial(false);
        if (materials.length > 0 && !value) {
          // setSelectedMaterial({ material_name: materials[0].material_name });
        }
      } catch (error) {
        if (
          error.name === "CanceledError" ||
          error.code === "ERR_CANCELED" ||
          controller.signal.aborted
        ) {
          return;
        }

        setLoadingMaterial(false);
        toast.error(error?.response?.data?.message, { autoClose: 2000 });
      }
    },
    [selectedSubCategory?.id, selectedHSCode?.hsncode],
  );

  // Auto-fetch when dependencies change
  React.useEffect(() => {
    fetchDataMaterial(false);
  }, [fetchDataMaterial]);

  // Cleanup on unmount
  React.useEffect(() => {
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);
  useEffect(() => {
    if (selectedHeader) {
      setSelectedCountry(selectedHeader);
    }
  }, [selectedHeader]);

  const handleToggle = () => {
    setGoButton((prev) => !prev);
    setGoButton(true);
  };

  function updateChangeSubCategory(e) {
    setSelectedSubCategory(e.target.value);
    setUserEdited(true);
    // old: no bookmark reset here
    if (from === "bookmark") {
      setFrom("");
      setId(null);
    }
    setSelectedRows([]);
    setSelectedCity("");
    setSelectedCountry("");
    setSelectedMaterial({});
    setDestinationCountryList([]);
    setMaterialList([]);
    setCityList([]);
    setPortList([]);
    setHSCode([]);
    setSelectedPort("");
    setSelectedHSCode("");
  }

  function updateChangeSubCategoryTextInput(e) {
    const newVal = e.target.value;

    // Normalize input
    const textValue = typeof newVal === "string" ? newVal : newVal?.name || "";

    // Clear previous timer
    clearTimeout(debounceTimerSubCategoryRef.current);

    // Set new timer
    debounceTimerSubCategoryRef.current = setTimeout(() => {
      fetchDataSubCategory(textValue, 1);
    }, 300); // 300ms debounce
  }

  //update hs code or  hs code selection
  function updateChangeHSCode(e) {
    setSelectedHSCode(e.target.value);
    setSelectedMaterial({});
    // Clear the stale Material options too — otherwise there's a brief
    // window where selectedMaterial is reset but materialList still holds
    // the previous HS Code's materials, and the old material can flash
    // back in via the auto-select effect once fetchDataMaterial resolves.
    setMaterialList([]);
    materialAutoSelectedForRef.current = undefined;
    materialSearchActiveRef.current = false;
    setSelectedCity("");
    setSelectedCountry("");
    setSelectedPort("");
    // Mark this subcategory as already resolved so a later HSCode list
    // refresh doesn't auto-select over the user's manual pick, and clear
    // any lingering search state now that a selection has been made.
    hsCodeAutoSelectedForRef.current = selectedSubCategory?.id || "";
    setHsCodeSearch("");
    // old: no bookmark reset here
    if (from === "bookmark") {
      setFrom("");
      setId(null);
    }
  }

  function updateChange(e) {
    setSelectedMaterial(e.target.value);
    setSelectedCountry("");
    setOriginCountry([]);
    setSelectedCity("");
    setSelectedPort("");
    // Mark this HS Code as already resolved so a later materialList
    // refresh doesn't auto-select over the user's manual pick.
    materialAutoSelectedForRef.current = selectedHSCode?.hsncode || "";
    materialSearchActiveRef.current = false;
    // old: no bookmark reset here
    if (from === "bookmark") {
      setFrom("");
      setId(null);
    }
    // setLoading(true);
  }

  function updateChangeMaterial(e) {
    const newVal = e.target.value;
    // Normalize input
    const materialName =
      typeof newVal === "string" ? newVal : newVal?.material_name || "";
    materialSearchActiveRef.current = !!materialName;
    // setSelectedCountry('');
    // Clear previous timer
    clearTimeout(debounceTimerRef.current);

    // Set new timer
    debounceTimerRef.current = setTimeout(() => {
      fetchDataMaterial(materialName);
    }, 300); // 300ms debounce

    // setSelected('')
  }

  async function fetchCountryListData() {
    try {
      if (from !== "bookmark" && from !== "dashboard") {
        if (!selectedMaterial?.material_name && !selectedHSCode) return;
        const countryList = await axiosInstance.post(
          "company/destination-country-list",
          {
            material_name: selectedMaterial?.material_name ?? "",
            hsncode: selectedHSCode?.hsncode,
          },
        );
        const countryListData = [];
        countryList?.data?.data?.destinationCountryData?.forEach((ele) => {
          countryListData.push(ele?.destination_country);
        });
        setDestinationCountryList(countryListData);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message, { autoClose: 2000 });
    }
  }

  useEffect(() => {
    if (selectedMaterial || selectedHSCode) fetchCountryListData();
  }, [selectedMaterial, selectedHSCode]);

  async function fetchOriginCountryListData() {
    try {
      // This is the only place originCountryList (the dropdown's available
      // options, as opposed to the selected values) gets populated — it
      // must always run, including when arriving from dashboard/bookmark,
      // otherwise the Origin Country dropdown has nothing to show even
      // though origin countries were already selected on the prior page.
      const response = await axiosInstance.post(
        "company/origin-country-list",
        {
          material_name: selectedMaterial?.material_name ?? "",
          destination_country: selectedCountry,
          hsncode: selectedHSCode?.hsncode,
        },
      );
      const originCountryList = [];
      response?.data?.data?.originCountryData?.forEach((ele) => {
        originCountryList.push(ele.origin_country);
      });
      setOriginCountryList(originCountryList);
    } catch (error) {
      toast.error(error?.response?.data?.message, { autoClose: 2000 });
    }
  }

  useEffect(() => {
    // HS Code is an optional refinement here too (see the City/Port fetch
    // above) — Destination Country is what actually gates this list.
    if (selectedCountry == "") return;
    fetchOriginCountryListData();
  }, [selectedCountry, selectedMaterial, selectedHSCode]);

  function updateOriginCountry(e) {
    const {
      target: { value },
    } = e;

    if (value.includes("all")) {
      if (originCountry?.length === originCountryList?.length) {
        setOriginCountry([]);
      } else {
        setOriginCountry(originCountryList?.map((item) => item));
      }
    } else {
      setOriginCountry(typeof value === "string" ? value.split(",") : value);
    }
  }

  //origin country from dashboard
  useEffect(() => {
    if (!selectedRows || userEdited) return;
    if (from === "dashboard") {
      // Normalize selectedRows into an array of strings
      let normalized = [];
      if (Array.isArray(selectedRows)) {
        normalized = selectedRows.map((c) =>
          typeof c === "object" ? c?.origin_country_name : String(c),
        );
      } else if (typeof selectedRows === "string") {
        normalized = selectedRows
          .split(",")
          .map((c) => c?.trim())
          .filter((c) => c?.length > 0);
      } else if (typeof selectedRows === "object") {
        normalized = [selectedRows?.origin_country_name];
      }

      // Map to details
      const value = normalized?.map((name) =>
        originCountryDetails.find(
          (item) => item?.origin_country?.toLowerCase() === name?.toLowerCase(),
        ),
      );

      setOriginCountryDetailsUpdated(value);
    }
  }, [selectedRows, originCountryDetails]);

  useEffect(() => {
    if (!originCountry) return;
    const normalized = Array.isArray(originCountry)
      ? originCountry
      : originCountry
          .split(",")
          .map((c) => c?.trim())
          .filter((c) => c?.length > 0);
    // const value = normalized &&  normalized?.map((name) =>
    //   originCountryDetails?.find((item) => {
    //     return item?.origin_country?.toLowerCase() === name?.toLowerCase();
    //   })
    // );
    const value = normalized
      ?.map((name) =>
        originCountryDetails?.find(
          (item) => item?.origin_country?.toLowerCase() === name?.toLowerCase(),
        ),
      )
      ?.filter(Boolean);

    if (from !== "dashboard" || userEdited) {
      setOriginCountryDetailsUpdated(value);
    }
    if (from !== "bookmark") {
      setOriginCountryDetailsUpdated(value);
    }
  }, [originCountry, originCountryDetails]);

  useEffect(() => {
    // old: no dashboard guard here
    if (from === "dashboard" && !userEdited) return;
    if (
      selectedMaterial?.material_name === "" ||
      selectedMaterial?.material_name === undefined
    ) {
      setOriginCountry([]);
      setOriginCountryDetailsUpdated([]);
    }
  }, [selectedMaterial]);

  useEffect(() => {
    if (from === "dashboard") {
      setOriginCountry(
        selectedRows?.map((item) => item?.origin_country_name) || [],
      );
    }
  }, [selectedRows]);

  // useEffect(() => {

  //   if (from === "bookmark") {
  //     // setOriginCountry(originCountryDetailsUpdated.map((item) => item?.origin_country));
  //   }
  // }, [originCountryDetailsUpdated]);

  useEffect(() => {
    if (
      !hasInitialized &&
      originCountryDetailsUpdated?.length &&
      from === "bookmark"
    ) {
      setOriginCountry(
        originCountryDetailsUpdated.map((item) => item?.origin_country),
      );
      setHasInitialized(true);
    }
  }, [originCountryDetailsUpdated, from, hasInitialized]);

  useEffect(() => {
    const isEmpty = (value) => {
      if (Array.isArray(value)) return value.length === 0;
      if (typeof value === "object" && value !== null)
        return Object.keys(value).length === 0;
      return !value; // handles null, undefined, ""
    };

    if (
      isEmpty(selectedHSCode) &&
      isEmpty(selectedMaterial) &&
      isEmpty(selectedSubCategory)
    ) {
      toast.error(
        "Please select Category,Destination Country And Origin Country to proceed",
      );
    }
  }, []);

  // Auto-select first HS Code on land / when the category changes and the
  // HS Code list loads — never while the user is actively searching, and
  // only once per subcategory so it doesn't refire on every keystroke.
  useEffect(() => {
    if (from === "dashboard" || from === "bookmark") return;
    if (hsCodeSearch) return;
    const subCategoryKey = selectedSubCategory?.id || "";
    if (
      HSCode?.length > 0 &&
      hsCodeAutoSelectedForRef.current !== subCategoryKey
    ) {
      setSelectedHSCode(HSCode[0]);
      hsCodeAutoSelectedForRef.current = subCategoryKey;
      // Clear stale Material state so it can't flash the previous HS
      // Code's selection while the new material list is still loading.
      setSelectedMaterial({});
      setMaterialList([]);
      materialAutoSelectedForRef.current = undefined;
      materialSearchActiveRef.current = false;
    }
  }, [HSCode]);

  // Auto-select first Material on land / when HS Code changes and the
  // Material list loads — never while the user is actively searching, and
  // only once per HS Code so it doesn't refire on every keystroke.
  useEffect(() => {
    if (from === "dashboard" || from === "bookmark") return;
    if (materialSearchActiveRef.current) return;
    const hsCodeKey = selectedHSCode?.hsncode || "";
    if (
      materialList?.length > 0 &&
      materialAutoSelectedForRef.current !== hsCodeKey
    ) {
      setSelectedMaterial(materialList[0]);
      materialAutoSelectedForRef.current = hsCodeKey;
    }
  }, [materialList]);

  // Auto-select first Destination Country when Material changes and country list loads
  useEffect(() => {
    if (from === "dashboard" || from === "bookmark") return;
    if (!selectedCountry && destinationCountryList?.length > 0) {
      setSelectedCountry(destinationCountryList[0]);
    }
  }, [destinationCountryList]);

  return (
    <>
      <Box sx={{ display: "block" }}>
        <ToastContainer position="top-right" />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginTop: "67px",
          }}
        >
          <div>
            <Header />
          </div>
          <Box
            sx={{
              ...FirstParaStyle,
            }}
          >
            <Box sx={{ ...backgroundStyle }}>
              <Box
                sx={{
                  backdropFilter: "blur(2px)",
                  padding: "20px",
                  borderRadius: "18px",
                  backgroundColor: "rgba(0, 0, 0, 0.6)",
                  color: "white",
                  lineHeight: "2",
                }}
              >
                <h4>TOOL GUIDE:</h4>
                <>
                  <ol>
                    <li>
                      Select the Destination Port & Factory location from the
                      drop down below based on the Destination Country selected
                      on the 1st view.
                    </li>
                    <li>
                      Then select the origin city and port options you would
                      like to analyze the prices for from the respective drop
                      downs.
                    </li>
                    <li>
                      Choose the desired price quotation type (EXW or FOB), and
                      enter your prices in USD/MT in the cells below and click
                      on ‘GO’.
                    </li>
                    <li>
                      As soon as you click ‘GO’, the world map and chart auto
                      populate and the lowest DDP price sourcing country gets
                      highlighted with a green navigation mark on the map.
                    </li>
                    <li>
                      The tool gives a feature to view the detailed cost
                      breakdown of all elements from EXW to the DDP price.
                    </li>
                  </ol>
                </>
              </Box>
            </Box>
          </Box>
          <Box className="details-header">
            <Box
              sx={{
                width: "100%",
                display: "flex",
                marginBottom: "15px",
              }}
            >
              <Box
                className="headerText"
                sx={{
                  justifyContent: "flex-start",
                }}
              >
                {/* {selectedMaterial ? selectedMaterial?.material_name : "N/A"} */}
              </Box>
            </Box>

            <Grid container spacing={2} sx={{ height: "auto" }}>
              {/* {SubCategory} */}

              <Grid item xs={12} lg={4}>
                {true && (
                  <>
                    <Box sx={{ ...dropDownHeader }}>
                      <img src={packageIMg} alt="img" />
                      {/* &nbsp; Select Category */}
                      &nbsp; Category
                    </Box>
                    <Autocomplete
                      // freeSolo
                      popupIcon={<ArrowDropDownIcon />}
                      options={subCategory}
                      getOptionLabel={(option) =>
                        typeof option === "string" ? option : option?.name || ""
                      }
                      value={selectedSubCategory ?? null}
                      loading={loadingSubCategory}
                      onChange={(event, newValue) =>
                        updateChangeSubCategory({
                          target: {
                            value:
                              typeof newValue === "string"
                                ? { name: newValue }
                                : newValue,
                          },
                        })
                      }
                      onInputChange={(event, newInputValue, reason) => {
                        setSubCategorySearch(newInputValue);
                        setSubCategoryPage(1);
                        if (reason === "input") {
                          updateChangeSubCategoryTextInput({
                            target: {
                              value: { name: newInputValue },
                            },
                          });
                        }
                      }}
                      ListboxComponent={(props) => (
                        <ListboxComponent
                          {...props}
                          onScrollBottom={() => {
                            if (subCategoryHasMore && !loadingSubCategory) {
                              setSubCategoryPage((prev) => prev + 1);
                            }
                          }}
                        />
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Select Category"
                          size="small"
                          sx={{
                            ...selectedBoxStyle,
                            "& .MuiInputBase-root": {
                              height: "32px",
                              fontSize: "12px",
                            },
                            "& .MuiInputBase-input": {
                              padding: "8px 12px",
                              fontSize: "12px",
                            },
                          }}
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <>
                                {loadingSubCategory ? (
                                  <CircularProgress color="inherit" size={18} />
                                ) : null}
                                {params.InputProps.endAdornment}
                              </>
                            ),
                          }}
                        />
                      )}
                      sx={{
                        "& .MuiAutocomplete-inputRoot": {
                          paddingRight: "32px !important",
                        },
                        "& .MuiAutocomplete-clearIndicator": {
                          color: "#fff",
                          backgroundColor: "#1976d2",
                          borderRadius: "50%",
                          "&:hover": {
                            backgroundColor: "#1565c0",
                          },
                        },
                      }}
                      componentsProps={{
                        popper: {
                          sx: {
                            "& .MuiAutocomplete-option": {
                              minHeight: "24px",
                              fontSize: "12px",
                              padding: "2px 8px",
                            },
                          },
                        },
                      }}
                    />
                  </>
                )}
              </Grid>
              {/* hs code */}

              <Grid item xs={12} lg={4}>
                {true && (
                  <>
                    <Box sx={{ ...dropDownHeader }}>
                      <img src={originCountryImg} alt="img" />
                      &nbsp;
                      <span>HS Code</span>
                      {/* <span>Select HS Code</span> */}
                    </Box>
                    <FormControl fullWidth>
                      <Autocomplete
                        loading={loadingHSCode}
                        options={HSCode}
                        // getOptionLabel={(option) =>
                        //   option?.hsncode ? option?.hsncode : ""
                        // }
                        // getOptionLabel={(option) =>
                        //   option?.hsncode
                        //     ? option.hsncode +
                        //       " -- " +
                        //       option?.hs_code_short_description
                        //     : ""
                        // }
                        getOptionLabel={(option) => {
                          const hsncode = option?.hsncode || "";
                          const description =
                            option?.hs_code_short_description || "";
                          return hsncode
                            ? `${hsncode} -- ${description}`
                            : description;
                        }}
                        value={selectedHSCode ?? null}
                        onChange={(event, newValue) =>
                          updateChangeHSCode({
                            target: { value: newValue },
                          })
                        }
                        onInputChange={(event, value, reason) => {
                          if (reason === "input") {
                            setHsCodeSearch(value);
                          } else if (reason === "clear") {
                            setHsCodeSearch("");
                          }
                        }}
                        filterOptions={(x) => x}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Select HS code"
                            size="small"
                            sx={{
                              ...selectedBoxStyle,
                              "& .MuiInputBase-root": {
                                height: "32px",
                                fontSize: "12px",
                              },
                              "& .MuiInputBase-input": {
                                padding: "8px 12px",
                                fontSize: "12px",
                              },
                            }}
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <>
                                  {loadingHSCode ? (
                                    <CircularProgress
                                      color="inherit"
                                      size={18}
                                    />
                                  ) : null}
                                  {params.InputProps.endAdornment}
                                </>
                              ),
                            }}
                          />
                        )}
                        sx={{
                          "& .MuiAutocomplete-inputRoot": {
                            paddingRight: "32px !important",
                          },
                          "& .MuiAutocomplete-clearIndicator": {
                            color: "#fff",
                            backgroundColor: "#1976d2",
                            borderRadius: "50%",
                            "&:hover": {
                              backgroundColor: "#1565c0",
                            },
                          },
                        }}
                        componentsProps={{
                          popper: {
                            sx: {
                              "& .MuiAutocomplete-option": {
                                minHeight: "24px",
                                fontSize: "12px",
                                padding: "2px 8px",
                              },
                            },
                          },
                        }}
                      />
                    </FormControl>
                  </>
                )}
              </Grid>
              {/* material list */}
              <Grid item xs={12} lg={4}>
                {true && (
                  <>
                    <Box sx={{ ...dropDownHeader }}>
                      <img src={packageIMg} alt="img" />
                      &nbsp; Material
                    </Box>
                    <Autocomplete
                      // freeSolo
                      popupIcon={<ArrowDropDownIcon />}
                      options={materialList}
                      getOptionLabel={(option) =>
                        typeof option === "string"
                          ? option
                          : option?.material_name || ""
                      }
                      // 👇 unwrap value for Autocomplete — strictly null
                      // when there's no real material_name, so a cleared
                      // selection ({}) never renders stale/mismatched text.
                      value={
                        selectedMaterial?.material_name
                          ? selectedMaterial
                          : typeof selectedMaterial === "string" &&
                              selectedMaterial
                            ? selectedMaterial
                            : null
                      }
                      onChange={(event, newValue) => {
                        let valueToSave =
                          typeof newValue === "string"
                            ? { material_name: newValue }
                            : newValue;

                        updateChange({
                          target: { value: valueToSave },
                        });
                      }}
                      onInputChange={(event, newInputValue, reason) => {
                        if (reason === "input") {
                          updateChangeMaterial({
                            target: {
                              value: { material_name: newInputValue },
                            },
                          });
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Select Material"
                          size="small"
                          sx={{
                            ...selectedBoxStyle,
                            "& .MuiInputBase-root": {
                              height: "32px",
                              fontSize: "12px",
                            },
                            "& .MuiInputBase-input": {
                              padding: "8px 12px",
                              fontSize: "12px",
                            },
                          }}
                        />
                      )}
                      sx={{
                        "& .MuiAutocomplete-inputRoot": {
                          paddingRight: "32px !important",
                        },
                        "& .MuiAutocomplete-clearIndicator": {
                          color: "#fff",
                          backgroundColor: "#1976d2",
                          borderRadius: "50%",
                          "&:hover": {
                            backgroundColor: "#1565c0",
                          },
                        },
                      }}
                      componentsProps={{
                        popper: {
                          sx: {
                            "& .MuiAutocomplete-option": {
                              minHeight: "24px",
                              fontSize: "12px",
                              padding: "2px 8px",
                            },
                          },
                        },
                      }}
                    />
                  </>
                )}
              </Grid>
              {/* destination country */}
              <Grid item xs={12} lg={3}>
                <Box sx={{ ...dropDownHeader }}>
                  <img src={destinationCountryImg} /> &nbsp; Destination Country
                </Box>
                <FormControl fullWidth>
                  {/* <InputLabel id="country-label">Country</InputLabel> */}
                  <Select
                    value={selectedCountry}
                    fullWidth
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    size="small"
                    displayEmpty
                    renderValue={(selected) => {
                      if (!selected) {
                        return (
                          <span
                            style={{
                              ...placeHolderStyle,
                            }}
                          >
                            Select Destination Country
                          </span>
                        );
                      }
                      return selected;
                    }}
                    sx={{
                      ...dropDownStyle,
                    }}
                    onChange={(e) => {
                      setSelectedCountry(e.target.value);
                      setOriginCountryDetailsUpdated([]);
                      setOriginCountry([]);
                    }}
                  >
                    {destinationCountryList?.map((item, index) => (
                      <MenuItem key={index} value={item}>
                        {item}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              {/* destination city */}
              <Grid item xs={12} lg={3}>
                <Box sx={{ ...dropDownHeader }}>
                  {" "}
                  <img src={factoryLocationImg} /> &nbsp;Destination City
                </Box>
                <FormControl fullWidth>
                  <Select
                    size="small"
                    labelId="demo-multiple-checkbox-label"
                    sx={{
                      ...dropDownStyle,
                    }}
                    displayEmpty
                    renderValue={(selected) => {
                      if (!selected) {
                        return (
                          <span
                            style={{
                              ...placeHolderStyle,
                            }}
                          >
                            Select Destination City
                          </span>
                        );
                      }
                      return selected;
                    }}
                    value={selectedCity}
                    onChange={(e) => setSelectedCity(e.target.value)}
                  >
                    {Array.isArray(cityList) &&
                      cityList.map((item, index) => (
                        <MenuItem key={index} value={item}>
                          {item}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
              {/* destination port */}
              <Grid item xs={12} lg={3}>
                <Box sx={{ ...dropDownHeader }}>
                  <img src={destinationPortImg} /> &nbsp; Destination Port
                </Box>
                <FormControl fullWidth>
                  <Select
                    size="small"
                    labelId="demo-multiple-checkbox-label"
                    // style={{ height: 20, fontSize: "13px" }}
                    sx={{
                      ...dropDownStyle,
                    }}
                    displayEmpty
                    renderValue={(selected) => {
                      if (!selected) {
                        return (
                          <span
                            style={{
                              ...placeHolderStyle,
                            }}
                          >
                            Select Destination Port
                          </span>
                        );
                      }
                      return selected;
                    }}
                    value={selectedPort}
                    onChange={(e) => setSelectedPort(e.target.value)}
                  >
                    {portList &&
                      portList.map((item, index) => (
                        <MenuItem key={index} value={item}>
                          {item}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
              {/* origin country */}
              <Grid item xs={12} lg={3}>
                <Box sx={{ ...dropDownHeader }}>
                  <img src={originCountryImg} alt="img" />
                  &nbsp;
                  <span>Origin Country</span>
                </Box>
                <FormControl fullWidth>
                  <Select
                    fullWidth
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    // value={originCountry}
                    value={
                      Array.isArray(originCountry)
                        ? originCountry?.map((c) =>
                            typeof c === "object" ? c.name : c,
                          )
                        : typeof originCountry === "object"
                          ? [originCountry?.name]
                          : originCountry
                            ? [originCountry]
                            : []
                    }
                    onChange={(e) => updateOriginCountry(e)}
                    size="small"
                    multiple
                    displayEmpty
                    inputProps={{ "aria-label": "Without label" }}
                    sx={{
                      ...dropDownStyle,
                    }}
                    renderValue={(selected) => {
                      if (selected.length === 0) {
                        return (
                          <span style={{ color: "#8d8f9d", fontSize: 12 }}>
                            Select Origin Country
                          </span>
                        );
                      }
                      return selected.join(", ");
                    }}
                    MenuProps={MenuProps}
                  >
                    <MenuItem
                      value="all"
                      sx={{
                        ...menuColor,
                        fontSize: "12px",
                        padding: "0px 12px",
                        height: "32px",
                      }}
                    >
                      <Checkbox
                        checked={
                          originCountry?.length === originCountryList?.length
                        }
                      />
                      Select All
                    </MenuItem>
                    {originCountryList.map((item, index) => (
                      <MenuItem
                        key={index}
                        value={item}
                        sx={{
                          ...menuColor,
                          fontSize: "12px",
                          padding: "4px 12px",
                          height: "32px",
                        }}
                      >
                        <Checkbox checked={originCountry?.includes(item)} />
                        {item}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box>

          <div
            style={{
              height: "auto",
              width: "100%",
            }}
          >
            <PortAndCityRow
              // originCountryDetails={originCountryDetails}
              originCountryDetails={originCountryDetailsUpdated}
              selectedHeader={selectedHeader}
              goButton={goButton}
              executeScroll={() => {}}
              setGoButton={setGoButton}
              handleToggle={handleToggle}
              from={from}
              currencyList={currencyList}
              scrollToDownRef={scrollToDownRef}
            />
          </div>
          {selectedCountry && (
            <EditableTable
              selectedMaterial={selectedMaterial}
              selectedCountry={selectedCountry}
              selectedRows={selectedRows}
              selectedHeader={selectedCountry}
              selectedCity={selectedCity}
              selectedPort={selectedPort}
              destinationCountryDataList={destinationCountryData}
              id={id}
              goButton={goButton}
              currencyList={currencyList}
              from={from}
              selectedHSCode={selectedHSCode}
              selectedSubCategory={selectedSubCategory}
              scrollToDownRef={scrollToDownRef}
              timePeriodBookmark={location?.state?.selectedTime}
            />
          )}
        </div>
      </Box>
    </>
  );
}
